import { DOMAIN_TYPE_TYPING_QUEUE } from './../../../consts';
export var getTypingQueue = function (state) {
    return state.domain[DOMAIN_TYPE_TYPING_QUEUE] || 0;
};
